import Title from "../components/TheTitle.vue";
import { searchPointExcludedProductCode, getBrandsMaster, getPointTypesMaster, } from "../api";
import { Validation } from "../utils/validation";
import { Authorize } from "../utils/authorize";
export default {
    components: { Title },
    data() {
        return {
            pointInfo: [],
            brandInfo: [],
            form: {
                brand_id: "",
                item_code: "",
                item_name: "",
                point_type_id: "",
            },
            tableInfo: [],
            infoPage: 1,
            pageSize: 100,
        };
    },
    computed: {
        infoTotalPages() {
            return Math.max(1, Math.ceil(this.tableInfo.length / this.pageSize));
        },
        pagedInfo() {
            const start = (this.infoPage - 1) * this.pageSize;
            return this.tableInfo.slice(start, start + this.pageSize);
        },
    },
    watch: {
        "form.point_type_id": async function (newPointType) {
            if (!newPointType) {
                this.brandInfo = [];
                this.form.brand = "";
                return;
            }
            try {
                const response = await getBrandsMaster(newPointType);
                if (response.result?.code === 9) {
                    this.$store.commit("setMessages", response.result.messages);
                    this.$store.commit("setCancelBtnHide", true);
                    this.$store.commit("setIsModalOpen", true);
                }
                else {
                    this.brandInfo = response.data.results || [];
                    if (!this.storeInfo.find((b) => b.brandId === this.form.brand)) {
                        this.form.brand = "";
                    }
                }
            }
            catch (err) {
                //
            }
        },
    },
    async created() {
        await this.callApi();
    },
    methods: {
        formatItemCode(code) {
            return code?.toString() || "";
        },
        validate(params) {
            // エラーメッセージを格納する配列
            const errors = [];
            // 桁数チェック
            if (params.item_code) {
                errors.push(...Validation.digitsMax({
                    key: "商品コード",
                    value: params.item_code,
                }, 40));
            }
            if (params.item_name) {
                errors.push(...Validation.digitsMax({
                    key: "商品名",
                    value: params.item_name,
                }, 50));
            }
            // 属性チェック
            if (params.item_code) {
                errors.push(...Validation.isNotContainSymbols({
                    key: "商品コード",
                    value: params.item_code,
                }));
            }
            if (errors.length > 0) {
                return errors;
            }
            return "";
        },
        async onSearch() {
            const filters = {
                brand_id: this.form.brand_id || undefined,
                item_code: this.form.item_code || undefined,
                item_name: this.form.item_name || undefined,
                point_type_id: this.form.point_type_id || undefined,
            };
            const errorMessage = this.validate(filters);
            if (errorMessage) {
                this.$store.commit("setMessages", errorMessage);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
                return;
            }
            const response = await searchPointExcludedProductCode(filters);
            if (response.result?.code === 9) {
                this.$store.commit("setMessages", response.result.messages);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
            }
            else {
                this.tableInfo = response.data?.results || [];
                this.infoPage = 1; // 検索後は1ページ目に戻す
            }
        },
        setInfoPage(page) {
            if (page < 1)
                page = 1;
            if (page > this.infoTotalPages)
                page = this.infoTotalPages;
            this.infoPage = page;
        },
        onEdit(row) {
            this.$router.push({
                path: "/updatePointExcludedProductCode",
                query: {
                    non_target_point_grant_id: row.non_target_point_grant_id,
                    point_type_id: row.point_type_id,
                    brand_id: row.brand_id,
                    item_code: row.item_code,
                    item_name: row.item_name,
                },
            });
        },
        onClear() {
            this.form = {
                brand_id: "",
                item_code: "",
                item_name: "",
                point_type_id: "",
            };
            this.tableInfo = [];
            this.infoPage = 1;
        },
        onDelete(row) {
            this.$router.push({
                path: "/deletePointExcludedProductCode",
                query: {
                    non_target_point_grant_id: row.non_target_point_grant_id,
                    point_type_id: row.point_type_id,
                    brand_id: row.brand_id,
                    item_code: row.item_code,
                    item_name: row.item_name,
                },
            });
        },
        async callApi() {
            try {
                // ブランドマスタ取得
                const gbResponse = await getBrandsMaster();
                if (gbResponse.result?.code === 9) {
                    this.$store.commit("setMessages", gbResponse.result.messages);
                    this.$store.commit("setCancelBtnHide", true);
                    this.$store.commit("setIsModalOpen", true);
                }
                else {
                    this.brandInfo = gbResponse.data.results;
                }
                // ポイント種別マスタ取得
                const gPMResponse = await getPointTypesMaster();
                if (gPMResponse.result?.code === 9) {
                    this.$store.commit("setMessages", gPMResponse.result.messages);
                    this.$store.commit("setCancelBtnHide", true);
                    this.$store.commit("setIsModalOpen", true);
                }
                else {
                    this.pointInfo = gPMResponse.data.results;
                }
            }
            catch (error) {
                //
            }
        },
    },
    async mounted() {
        await Authorize.isExpired(this);
    },
};
